// extracted by mini-css-extract-plugin
export default {"popupGenFreeAIResponse":"PopupGenFreeAIResponse_popupGenFreeAIResponse__WX5Id","subtitle":"PopupGenFreeAIResponse_subtitle__0-gRV","tooltip":"PopupGenFreeAIResponse_tooltip__a+W20"};